import { render, staticRenderFns } from "./examinationAssignmentsAssignedDialog.vue?vue&type=template&id=dc53a618"
import script from "./examinationAssignmentsAssignedDialog.vue?vue&type=script&lang=js"
export * from "./examinationAssignmentsAssignedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports